import React, { Component } from 'react';
import { connect } from 'react-redux';

class GovernmentCheckbox extends Component {
    render = () => {
        return (
            <label className="grid-item checkbox checkbox-government">
                <span className="label">{this.props.sender.name}</span>
                <input type="checkbox" id={this.props.id} defaultChecked={this.props.active} onChange={(e) => this.props.checkMethod(e)} />
                
                <span className="checkmark government-checkmark" />
            </label>
        );
    };
}

const mapStateToProps = (state, ownProps) => {
    return {};
};

GovernmentCheckbox = connect(mapStateToProps)(GovernmentCheckbox);

export default GovernmentCheckbox;





// WEBPACK FOOTER //
// ./src/components/settings/GovernmentCheckbox.js